import axios from "axios";
import { ResponseError } from "types/responses/ResponseError";
import { removeAccessToken } from "./AccessToken";
import { getHeaders } from "./AuthHeader";
const API_URL = process.env.REACT_APP_API_URL;

async function LogOutUser(client_id: any, connection_id: any) {
    try {
        const response = await axios.post(
            API_URL + "/logout", {
                client_id: client_id, 
                connection_id: connection_id
            }, {
                headers: getHeaders()
            })

        let status = JSON.parse(response.data.user)
        // console.log(status)
        removeAccessToken()
        
        return status

    } catch(error) {
        // console.log("ERROR:");
        // console.error(JSON.stringify(error));
        return ResponseError.general_error
    }
}

export default LogOutUser